// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".echarts{width:14.49275rem;height:9.66184rem}", ""]);
// Exports
module.exports = exports;
